<template>
    <div class="lingganTool">
        <el-popover ref="lingganPopover" placement="right-start" :visible-arrow="false" trigger="manual" v-model="visible"
            popper-class="lingganTool_popover" @show="onPopoverShow" @hide="onPopoverHide" :open-delay="0"
            :close-delay="0">
            <div class="trigger_btn" :style="`width: calc(100% - ${calc_width}px);margin-top: ${trigger_top}px;`" slot="reference" @click="togglePopover">
                <div class="left_tool">
                    <img src="@/components/images/lingganImg/linggan.gif" alt="">
                    <div class="tool_name">灵感库</div>
                </div>
                <div class="right_tool">超过{{use_num}}人使用</div>
                <div class="jiantou" v-show="visible"></div>
            </div>
            <div class="lingganTool_popup" @click.stop>
                <div class="popup_title">
                    <div class="title_text">灵感库</div>
                    <div class="close" @click="visible = false; show_detail_popup = false;search_text = ''">
                        <img src="@/components/images/lingganImg/close.png" alt="">
                    </div>
                </div>
                <div class="search_box">
                    <div class="shaixuan_box">
                        <div class="shai_item active" @click="shaixuan(0)">精选推荐</div>
                        <div class="shai_item" @click="shaixuan(1)">最新发布</div>
                        <div class="shai_item" @click="shaixuan(2)">热门作品</div>
                    </div>
                    <div class="search" ref="searchWrap" @click="search_detail">
                        <i class="el-icon-search" v-show="!search_detail_visible"></i><span v-show="!search_detail_visible">搜索</span>
                        <div class="search_close_box" v-show="search_detail_visible" @click.stop="search_detail_visible = false;search_text = '';get_tool_data()">
                            <img src="@/components/images/lingganImg/close.png" class="search_close" alt="">
                        </div>
                        <div class="search_detail" :class="{'show': search_detail_visible}" @click.stop>
                            <el-input
                                placeholder="请输入内容"
                                v-model="search_text"
                                clearable
                                style="height: 30px;"
                                @clear="onSearchClear"
                                @keyup.enter.native="page=1;get_tool_data(false)"
                            >
                            </el-input>
                        </div>
                    </div>
                </div>
                <div class="tool_list">
                    <div class="masonry">
                        <div class="masonry-item" v-for="(item, index) in tool_list" :key="index" @click="show_detail(item)" @mouseenter="playVideo(index)" @mouseleave="pauseVideo(index)" :style="item._imgError ? { height: defaultItemHeight + 'px' } : null">
                            <img class="cover_img" :src="item.cdn_output_cover_url" :alt="item.id || 'cover'" @error="onCoverError(index)" @load="onCoverLoad(index)" v-show="!item._imgError">
                            <div class="btn" @click.stop="show_detail(item)">查看详情</div>
                        </div>
                        <div ref="loadMoreSentinel" class="load-more-sentinel"></div>
                    </div>
                </div>
            </div>

        </el-popover>
        <!-- 灵感库详细信息弹窗 -->
        <div class="detail_popup" :class="{ 'show': show_detail_popup, 'hide': !show_detail_popup && !isInitialState }"
            @click.stop>
            <div class="popup_title">
                <div class="title_text">作品信息</div>
                <div class="close" @click="show_detail_popup = false; isInitialState = false">
                    <img src="@/components/images/lingganImg/close.png" alt="">
                </div>
            </div>
            <div class="detail_content">
                <div class="img_box" v-if="show_list.includes('img_urls')">
                    <img :src="tool_form.cdn_img_url" alt="">
                </div>
                <!-- 多图查看 -->
                <div class="img_box" v-if="show_list.includes('img_array')">
                    <img :src="tool_form.cdn_ingredients[curent_shouwei]" alt="">
                </div>
                <div class="det_item_title"
                    v-if="(show_list.includes('img_urls') || show_list.includes('img_array'))&& tool_form.upload_list.length > 1">
                    <div class="title_text">图片选项</div>
                    <img src="@/components/images/lingganImg/add.png" class="add_item" alt="" @click="set_shouwei"
                        v-show="show_list.includes('img_urls')">
                    <img src="@/components/images/lingganImg/add.png" class="add_item" alt="" @click="set_img_arr"
                        v-show="show_list.includes('img_array')">
                </div>
                <div class="img_list"
                    v-if="show_list.includes('img_urls') && tool_form.upload_list.length > 1">
                    <!-- 首帧 -->
                    <div class="img_item active" @click="select_img(0)">
                        <img :src="tool_form.cdn_img_url" alt="">
                    </div>
                    <!-- 尾帧 -->
                    <div class="img_item" @click="select_img(1)" v-show="tool_form.img_urls">
                        <img :src="tool_form.cdn_img_urls" alt="">
                    </div>
                </div>
                <div class="img_list" v-if="show_list.includes('img_array')">
                    <!-- 多图选择 -->
                    <div class="img_item" :class="curent_shouwei == index ? 'active' : ''"
                        v-for="(item, index) in tool_form.cdn_ingredients" @click="select_img(index)" :key="index">
                        <img :src="item" alt="">
                    </div>
                </div>
                <!-- 参考视频 -->
                <!-- <div class="img_box img_box_video" v-if="show_list.includes('ref_video')">
                    <video :src="tool_form.video_url" controls></video>
                </div> -->
                <div class="det_item_title det_item_title_other" v-if="show_list.includes('desc')">
                    <div class="title_text">
                        提示词
                        <img @click="copy_prompt(tool_form.desc)" src="@/components/images/lingganImg/copy.png"
                            class="copy_img" alt="">
                    </div>
                    <img src="@/components/images/lingganImg/add.png" class="add_item" alt="" @click="use_only('desc')">
                </div>
                <div class="desc_box" v-if="show_list.includes('desc')">
                    <div class="desc_text">
                        {{ tool_form.desc }}
                    </div>
                </div>
                <!-- 选择模型 -->
                <div class="det_item_title" v-if="show_list.includes('model')">
                    <div class="title_text">风格</div>
                    <img src="@/components/images/lingganImg/add.png" class="add_item" alt=""
                        @click="use_only('model')">
                </div>
                <div class="model_list" v-if="show_list.includes('model')">
                    <div :class="tool_form.model == item.name ? 'model_item active' : 'model_item'"
                        v-for="(item, index) in model_list" @click="select_model(item)" :key="index">
                        {{ item.name }}
                    </div>
                </div>
                <!-- 选择尺寸 -->
                <div class="det_item_title" v-if="show_list.includes('size')">
                    <div class="title_text">尺寸</div>
                    <img src="@/components/images/lingganImg/add.png" class="add_item" alt="" @click="use_only('size')">
                </div>
                <div class="model_list" v-if="show_list.includes('size')">
                    <div :class="tool_form.size == (item.size?item.size:item.name) ? 'model_item active' : 'model_item'"
                        v-for="(item, index) in size_list" @click="select_size(item)" :key="index">
                        {{ item.size?item.size:item.name }}
                    </div>
                </div>
                <!-- 选择清晰度 -->
                <div class="det_item_title" v-if="show_list.includes('quality')">
                    <div class="title_text">清晰度</div>
                    <img src="@/components/images/lingganImg/add.png" class="add_item" alt=""
                        @click="use_only('quality')">
                </div>
                <div class="model_list" v-if="show_list.includes('quality')">
                    <div :class="tool_form.quality == item.type ? 'model_item active' : 'model_item'"
                        v-for="(item, index) in quality_list" @click="select_quality(item)" :key="index">
                        {{ item.name }}
                    </div>
                </div>
                <!-- 选择时长 -->
                <div class="det_item_title" v-if="show_list.includes('duration')">
                    <div class="title_text">选择时长</div>
                    <img src="@/components/images/lingganImg/add.png" class="add_item" alt=""
                        @click="use_only('duration')">
                </div>
                <div class="model_list" v-if="show_list.includes('duration')">
                    <div :class="tool_form.duration == item.value ? 'model_item active' : 'model_item'"
                        v-for="(item, index) in duration_list" @click="select_duration(item)" :key="index">
                        {{ item.name }}
                    </div>
                </div>

                <!-- 选择相似度 -->
                <div class="det_item_title" v-if="show_list.includes('iw')">
                    <div class="title_text">相似度</div>
                    <img src="@/components/images/lingganImg/add.png" class="add_item" alt=""
                        @click="use_only('bgMode')">
                </div>
                <div class="model_list" v-if="show_list.includes('iw')">
                    <div :class="tool_form.iw == item.value ? 'model_item active' : 'model_item'"
                        v-for="(item, index) in iw_list" @click="select_iw(item)" :key="index">
                        {{ item.value }}
                    </div>
                </div>

                <!-- 高级设置 -->
                <div class="det_item_title" v-if="show_list.includes('set_detail')">
                    <div class="title_text">高级设置</div>
                    <img src="@/components/images/lingganImg/add.png" class="add_item" alt=""
                        @click="use_only('set_detail')">
                </div>
                <div class="set_detail_list" v-if="show_list.includes('set_detail')">
                    <!-- <div class="set_detail_item" v-show="tool_form.option_json.img_model">
                        <div class="set_name">模型</div>
                        <div class="set_value">{{ tool_form.option_json.img_model }}</div>
                    </div> -->
                    <div class="set_detail_item" v-show="tool_form.option_json.iw!=0&&tool_form.option_json.iw!=null">
                        <div class="set_name">图片相似度</div>
                        <div class="set_value">{{ tool_form.option_json.iw }}</div>
                    </div>
                    <div class="set_detail_item" v-show="tool_form.option_json.parameters.aspect">
                        <div class="set_name">生成尺寸</div>
                        <div class="set_value">{{ tool_form.option_json.parameters.aspect }}</div>
                    </div>
                    <div class="set_detail_item" v-show="tool_form.option_json.parameters.quality">
                        <div class="set_name">质量化</div>
                        <div class="set_value">{{ tool_form.option_json.parameters.quality }}</div>
                    </div>
                    <div class="set_detail_item" v-show="tool_form.option_json.pic_num">
                        <div class="set_name">绘图模式</div>
                        <div class="set_value">{{ tool_form.option_json.pic_num==1?'单图':'多图' }}</div>
                    </div>
                </div>
            </div>
            <div class="create_list" @click="create_same">
                <div class="btn_create">
                    做同款
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils/index.js'
import AliCdn from '@/utils/ali_cdn'

export default {
    props: {
        trigger_top: {
            type: Number,
            default: 0
        },
        calc_width: {
            type: Number,
            default: 0
        },
        MD5_KEY: {
            type: String,
            default: ''
        },
        show_list: {
            type: Array,
            default: () => []
        },
        //多图选择
        img_array: {
            type: Array,
            default: () => []
        },
        //选择时长
        duration_list: {
            type: Array,
            default: () => []
        },
        //清晰度列表
        quality_list: {
            type: Array,
            default: () => []
        },
        //模型列表
        model_list: {
            type: Array,
            default: () => []
        },
        //比例尺寸
        size_list: {
            type: Array,
            default: () => []
        },
        //相似度列表
        iw_list: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            use_num: 0,
            visible: false,
            show_detail_popup: false,
            isInitialState: true,
            search_detail_visible: false,
            tool_list: [],
            curent_shouwei: 0,
            // 瀑布流加载控制
            page: 1,
            isLoading: false,
            hasMore: true,
            pageSize: 16,
            io: null,
            defaultItemHeight: 180,
            tool_form: {
                desc: 'test',
                id: null,
                img_url: '',
                img_urls: '',
                model: '',
                ingredients: [],
                upload_list:[],
                option_json:{
                    parameters:{}
                }
            },
            cdnOptions: {
                cdnDomain: "cdnmjimg2024.m.nengshuohuihua.com"
            },
            search_text: '',
            shaixuan_index: 0,
        }
    },
    methods: {
        set_use_num(){
            //根据不同的路由设置use_num
            if(localStorage.getItem(`${this.$route.path}_use_num`)){
                this.use_num = localStorage.getItem(`${this.$route.path}_use_num`)
            }else{
                this.use_num = utils.getRandomInt(1000, 10000)
                localStorage.setItem(`${this.$route.path}_use_num`, this.use_num)
            }
        },
        search_detail(){
            //如果search_text为空，点击正常显示隐藏search_detail
            if (this.search_text == ''){
                this.search_detail_visible = !this.search_detail_visible;
            }else{
                if (this.search_detail_visible) {
                    this.$nextTick(() => {
                        const input = this.$el.querySelector('.search_detail input');
                        if (input) input.focus();
                    });
                    this.page = 1;
                    this.hasMore = true;
                    this.get_tool_data(false);
                }
            }
        },
        shaixuan(index){
            this.shaixuan_index = index;
            document.querySelectorAll('.shai_item').forEach(item => {
                item.classList.remove('active');
            })
            document.querySelectorAll('.shai_item')[index].classList.add('active');
            this.page = 1;
            this.hasMore = true;
            this.get_tool_data(false);
        },
        onSearchClear() {
            this.page = 1;
            this.hasMore = true;
            this.get_tool_data(false);
                // 隐藏搜索浮层
                this.search_detail_visible = false;
        },
        togglePopover() {
            this.visible = !this.visible;
            this.show_detail_popup = false
            if (this.visible) {
                // 首次打开或无数据时加载
                if (!this.tool_list || this.tool_list.length === 0) {
                    this.page = 1;
                    this.hasMore = true;
                    this.get_tool_data(false);
                }
            }
        },
        cdn_url_replace(url, o_url, c_url){
            if (!url){
                return 
            }
            if (!c_url){
                c_url = 'https://cdnmjimgnas.m.nengshuohuihua.com'
            }
            if (!o_url){
                o_url = 'https://mjimg.zhanjuzhe.cn'
            }
            if (url.indexOf('https://mjimg2024.oss-cn-beijing.aliyuncs.com') > -1){
                return AliCdn.signUrl(url, this.cdnOptions)
            }
            if (url.indexOf('https://zjzai20251109.oss-cn-hangzhou.aliyuncs.com') > -1){
                return AliCdn.signUrl(url, {
                cdnDomain: "cdnzjzai.m.nengshuohuihua.com"
            })
            }
            return url.replace(o_url, c_url)
        },
        get_tool_data(append = false) {
            // if (this.isLoading) return;
            this.isLoading = true;
            this.show_detail_popup = false;
            const params = {
                md5_key: this.MD5_KEY,
                order: this.shaixuan_index,
                prompt: this.search_text,
                page_no: this.page,
                page_size: this.pageSize,
            };
            this.$http.get(
                // https://payadmin.m.nengshuohuihua.com
                `https://payadmin.m.nengshuohuihua.com/wap/siteconfig/goodexample/`, { params }

                // `http://192.168.1.11:3000/wap/siteconfig/goodexample/`, { params }
            ).then(res => {
                const list = Array.isArray(res.data) ? res.data : [];
                if (append) {
                    const merged = this.tool_list.concat(list);
                    // 按 id 去重，避免接口未分页导致重复
                    const seen = new Set();
                    this.tool_list = merged.filter(it => {
                        const key = it.id || it._id || JSON.stringify(it);
                        if (seen.has(key)) return false;
                        seen.add(key);
                        return true;
                    });
                } else {
                    this.tool_list = list;
                }
                // 简单的“是否还有更多”判断：返回数量小于pageSize则认为到底
                this.hasMore = list.length >= this.pageSize;
                if (this.hasMore) this.page += 1;
            }).finally(() => {
                this.isLoading = false;
            })
        },
        use_only(type) {
            this.$emit('use_only', { data: this.tool_form, type })
        },
        set_shouwei() {
            this.$emit('use_only', { data: this.tool_form, type: this.curent_shouwei })
        },
        set_img_arr() {
            this.$emit('use_only', { data: this.tool_form, type: 'img_array' })
        },
        select_img(data) {
            this.curent_shouwei = data;
            document.querySelectorAll('.img_item')[data].classList.add('active');
            document.querySelectorAll('.img_item').forEach((item, index) => {
                if (index !== data) {
                    item.classList.remove('active');
                }
            });
        },
        set_tool_form() {
            //选择时长
            if (this.duration_list.length) {
                this.tool_form.duration = this.duration_list[0].value;
            }
            //选择模型
            if (this.model_list.length) {
                this.tool_form.model = this.model_list[0].name;
            }
            //选择比例尺寸
            if (this.size_list.length) {
                this.tool_form.size = (this.size_list[0].size?this.size_list[0].size:this.size_list[0].name);
            }
            //选择清晰度
            if (this.quality_list.length) {
                this.tool_form.quality = this.quality_list[0].type;
            }
            //选择相似度
            if (this.iw_list.length) {
                this.tool_form.iw = this.iw_list[0].value;     
            }
            this.$forceUpdate()
        },
        //选择清晰度
        select_quality(data) {
            this.tool_form.quality = data.type;
            this.$forceUpdate()

        },
        //选择时长
        select_duration(data) {
            this.tool_form.duration = data.value;
            this.$forceUpdate()

        },
        //选择比例尺寸
        select_size(data) {
            this.tool_form.size = data.size?data.size:data.name;
            this.$forceUpdate()

        },
        //选择模型
        select_model(data) {
            this.tool_form.model = data.name;
        },
        //选择背景
        select_iw(data) {
            this.tool_form.iw = data.value;
            this.$forceUpdate()
        },
        onPopoverShow() {
            this.$nextTick(() => {
                const popper = document.querySelector('.lingganTool_popover');
                if (popper) {
                    // 对齐到message_list顶部
                    const messageList = document.querySelector('.draw_area_tips');
                    if (messageList) {
                        const messageListTop = messageList.getBoundingClientRect().top + 58;
                        popper.style.top = messageListTop + 'px';
                    }
                    // 初始状态：透明
                    popper.style.opacity = '0';
                    popper.style.transition = 'opacity 0.3s ease';
                    // 下一帧开始淡入
                    setTimeout(() => {
                        popper.style.opacity = '1';
                    }, 10);
                }
                // 更新detail_popup位置
                this.updateDetailPopupPosition();
                // 列表为空时加载第一页
                if (!this.tool_list || this.tool_list.length === 0) {
                    this.page = 1;
                    this.hasMore = true;
                    // this.get_tool_data(false);
                    // 下一页准备
                    // if (this.hasMore) this.page = 2;
                }
                // 设置观察器以便无限滚动
                this.setupInfiniteScrollObserver();
            });
        },
        setupInfiniteScrollObserver() {
            this.$nextTick(() => {
                // 清理旧的
                if (this.io) {
                    try { this.io.disconnect(); } catch (e) {}
                    this.io = null;
                }
                const sentinel = this.$refs.loadMoreSentinel;
                if (!sentinel) return;
                this.io = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting && !this.isLoading && this.hasMore) {
                            this.get_tool_data(true);
                        }
                    })
                }, { root: this.$el.querySelector('.tool_list') || null, rootMargin: '0px 0px 200px 0px', threshold: 0 });
                this.io.observe(sentinel);
            })
        },
        updateDetailPopupPosition() {
            this.$nextTick(() => {
                const popup = document.querySelector('.lingganTool_popup');
                const detailPopup = document.querySelector('.detail_popup');
                if (popup && detailPopup) {
                    const rect = popup.getBoundingClientRect();
                    detailPopup.style.top = rect.top + 'px';
                    detailPopup.style.left = (rect.right + 10) + 'px';
                }
            });
        },
        onPopoverHide() {
            const popper = document.querySelector('.lingganTool_popover');
            if (popper) {
                // 淡出效果
                popper.style.transition = 'opacity 0.3s ease';
                popper.style.opacity = '0';
            }
            // 关闭时清理观察器，避免不必要的触发
            if (this.io) {
                try { this.io.disconnect(); } catch (e) {}
                this.io = null;
            }
            // 隐藏搜索浮层
            this.search_detail_visible = false;
        },
        // 鼠标移入自动播放
        playVideo(index) {
            let video_list = document.querySelectorAll('.item_video');
            video_list.forEach((item, i) => {
                if (i === index) {
                    item.play();
                } else {
                    // 暂停并重置所有其他视频
                    item.pause();
                    item.currentTime = 0;
                    item.load();
                }
            });
        },
        // 鼠标移出暂停播放
        pauseVideo(index) {
            let video_list = document.querySelectorAll('.item_video');
            video_list.forEach((item, i) => {
                if (i === index) {
                    item.pause();
                    item.currentTime = 0;
                    // 重新加载以显示封面图
                    item.load();
                }
            });

        },
        show_detail(data) {
            this.show_detail_popup = true;
            this.tool_form.id = data.id;
            this.tool_form.desc = data.option_json.prompt;
            this.tool_form.img_url = data.input_json.img_url ? data.input_json.img_url : data.output_cover_url;
            this.tool_form.cdn_img_url = data.input_json.cdn_img_url ? data.input_json.cdn_img_url : data.cdn_output_cover_url;
            this.tool_form.output_url = data.output_url;
            this.tool_form.cdn_output_url = data.cdn_output_url;
            this.tool_form.option_json = data.option_json;
            this.tool_form.upload_list = data.input_json.upload_list;
            this.tool_form.cdn_upload_list = data.input_json.cdn_upload_list;

            this.$forceUpdate()
            // 更新detail_popup位置
            this.updateDetailPopupPosition();
        },
        create_same() {
            this.tool_form.md5_key = utils.setMd5Key(this.tool_form.id)
            this.$emit('createSame', this.tool_form)
            this.visible = false
            this.show_detail_popup = false
        },
        copy_prompt(data) {
            utils.copy_prompt(data)
        },
        onCoverError(index) {
            if (!this.tool_list || !this.tool_list[index]) return;
            // 置为失败态并隐藏图片，容器应用默认高度
            this.$set(this.tool_list[index], '_imgError', true);
        },
        onCoverLoad(index) {
            if (!this.tool_list || !this.tool_list[index]) return;
            // 图片成功加载，清除失败态（如果之前标记过）
            if (this.tool_list[index]._imgError) {
                this.$set(this.tool_list[index], '_imgError', false);
            }
        },
        handleGlobalClick(e) {
            // 仅当弹层可见且搜索浮层展开时处理
            if (!this.visible || !this.search_detail_visible) return;
            // 有值则不自动关闭
            if (this.search_text && this.search_text.trim() !== '') return;
            const root = this.$el;
            if (!root) return;
            const searchWrap = this.$refs.searchWrap;
            const searchDetail = searchWrap ? searchWrap.querySelector('.search_detail') : null;
            const target = e.target;
            // 如果点击发生在搜索区域内，则不关闭
            const inSearchArea = (searchWrap && (searchWrap === target || searchWrap.contains(target))) || (searchDetail && searchDetail.contains(target));
            if (inSearchArea) return;
            // 其它任意位置点击均关闭
            this.search_detail_visible = false;
        },
    },
    mounted() {
        this.set_tool_form()
        // 捕获阶段监听全局点击，即使内部有 stopPropagation 也能命中
        this._boundHandleGlobalClick = this.handleGlobalClick.bind(this);
        window.addEventListener('click', this._boundHandleGlobalClick, true);
        // console.log(this.size_list);
        // alert(this.size_list);
        // this.use_num = utils.getRandomInt(1000, 10000)
        this.set_use_num()
        
    },
    beforeDestroy() {
        if (this.io) {
            try { this.io.disconnect(); } catch (e) {}
            this.io = null;
        }
        if (this._boundHandleGlobalClick) {
            window.removeEventListener('click', this._boundHandleGlobalClick, true);
            this._boundHandleGlobalClick = null;
        }
    },
}
</script>

<style lang="scss" scoped>
.lingganTool {
    font-size: 14px;
    .trigger_btn {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        background: #1e1f22;
        margin: 0 auto;
        margin-top: 10px;
        border-radius: 6px;
        padding: 0 10px;
        font-size: 14px;
        cursor: pointer;
        margin-bottom: 12px;
        box-sizing: border-box;
        user-select: none;
        .jiantou{
            //左箭头
            position: absolute;
            right: -13px;
            width: 0;
            height: 0;
            border-top: 9px solid transparent;
            border-bottom: 9px solid transparent;
            border-right: 9px solid #06080d;
            z-index: 99;
        }
        .left_tool {
            display: flex;
            align-items: center;

            img {
                width: 20px;
                height: 20px;
                margin-left: 6px;
            }

            .tool_name {
                margin-left: 8px;
                font-weight: 600;
                color: transparent;
                background-image: linear-gradient(to right, #ff2a90, #ff4508);
                -webkit-background-clip: text;
                background-clip: text;
            }
        }

        .right_tool {
            color: #33312f;
        }
    }

    .detail_popup {
        position: fixed;
        width: 420px;
        max-height: calc(100vh - 100px);
        background: #06080d;
        border-radius: 6px;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;
        z-index: -1;
        cursor: default;
        opacity: 0;
        transition: opacity 0.3s ease, z-index 0s 0.3s;

        &.show {
            opacity: 1;
            z-index: 2001;
            transition: opacity 0.3s ease, z-index 0s 0s;
        }

        &.hide {
            opacity: 0;
            z-index: -1;
            transition: opacity 0.3s ease, z-index 0s 0.3s;
        }

        .detail_content {
            width: 100%;
            max-height: calc(100vh - 140px - 86px);
            overflow-x: hidden;
            overflow-y: auto;
            padding: 10px;
            padding-top: 0px;
            margin-top: 10px;

            .img_box {
                width: 100%;
                height: 264px;
                border-radius: 6px;
                overflow: hidden;
                border: 1px solid #232b3d;
                background: #10151f;

                img {
                    object-fit: contain;
                    width: 100%;
                    height: 100%;
                }

                //参考视频
                video {
                    object-fit: contain;
                    width: 100%;
                    height: 100%;
                }
            }

            .img_box_video {
                margin-top: 10px;
            }

            .det_item_title {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 10px;
                border-bottom: 2px solid #16171c;
                margin-top: 15px;

                .title_text {
                    display: flex;
                    align-items: center;

                    .copy_img {
                        width: 14px;
                        height: 14px;
                        margin-left: 10px;
                        margin-top: 1px;
                        cursor: pointer;
                    }
                }

                .add_item {
                    width: 18px;
                    height: 18px;
                    cursor: pointer;
                }
            }

            .det_item_title_other {
                border-bottom: none;
            }
            .set_detail_list{
                display: flex;
                flex-wrap: wrap;
                padding: 10px;
                .set_detail_item{
                    margin-right: 10px;
                    .set_value{
                        margin-top: 5px;
                    }
                }
                .set_detail_item:last-child{
                    margin-right: 0;
                }
            }

            .desc_box {
                width: 100%;
                padding: 8px;
                padding-right: 0;
                border-radius: 4px;
                color: #9094a6;
                background: #10151f;
                font-size: 12px;
                .desc_text{
                    max-height: 100px;
                    overflow-x: hidden;
                    overflow-y: auto;
                }
            }
        }

        .create_list {
            align-items: center;
            background: #070b15;
            box-shadow: 0 -1px 10px 0 rgba(184, 201, 205, .2);
            -moz-column-gap: 10px;
            column-gap: 10px;
            display: flex;
            height: 76px;
            justify-content: center;
            padding: 0 10px;
            width: 100%;

            .btn_create {
                width: 100%;
                height: 50px;
                line-height: 50px;
                text-align: center;
                border-radius: 4px;
                color: #FFFFFF;
                background: linear-gradient(to right, #6116ef, #ffac5b);
                font-size: 16px;
                cursor: pointer;

                &:hover {
                    background: linear-gradient(to right, #ffac5b, #6116ef);
                }
            }
        }
    }

    .model_list {
        display: flex;
        align-items: center;
        margin-top: 20px;
        user-select: none;

        .model_item {
            width: 88px;
            height: 40px;
            font-size: 14px;
            background-color: #1d2027;
            border-radius: 4px;
            border: 2px solid #1d2027;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
        }

        .model_item:last-child {
            margin-right: 0;
        }

        .active {
            border-color: #5865f2;
            background-color: rgba(88, 101, 242, 0.15);
        }
    }

    .img_list {
        display: flex;
        margin-top: 20px;

        .img_item {
            width: 100px;
            height: 100px;
            cursor: pointer;
            border: 2px solid transparent;
            margin-right: 10px;
            border-radius: 4px;
            overflow: hidden;

            &.active {
                border-color: #5865f2;
            }

            img {
                object-fit: cover;
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>

<style lang="scss">
// 自定义 popover 样式
.lingganTool_popover {
    padding: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
    border: none !important;
    z-index: 2001 !important;

    .popper__arrow::after {
        left: -12px !important;
        border-right-color: #06080d !important;
        border-width: 9px !important;
        border-top-color: transparent !important;
    }
}

.popup_title {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #FFFFFF;
    background: #10151f;
    padding: 0 10px;
    user-select: none;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;

    .close {
        width: 14px;
        height: 14px;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

.lingganTool_popover {
    .lingganTool_popup {
        width: 320px;
        max-height: calc(100vh - 100px);
        background: #06080d;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: default;
        // margin-left: -1px;

        &.show {
            transform: translateX(0);
            // z-index: -10;
        }
        .search_box {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            padding: 0 10px;
            box-sizing: border-box;
            position: relative;
            // background: #ccc;
            margin-top: 5px;
            .shaixuan_box {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                // padding: 0 10px;
                box-sizing: border-box;
                background: #10151f;
                border-radius: 4px;
                .shai_item {
                    // width: 50px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    font-size: 12px;
                    color: #9094a6;
                    cursor: pointer;
                    padding: 0 10px;
                    &.active {
                        border-color: #5865f2;
                        background-color: rgba(88, 101, 242, 0.15);
                        color: #FFFFFF;
                    }
                    &:hover {
                        // color: #FFFFFF;
                        background-color: rgba(88, 101, 242, 0.15);
                    }
                    border: 1px solid #232b3d;
                    border-radius: 4px;
                    margin-right: 5px;
                }
                .shai_item:last-child {
                    margin-right: 0;
                }
                .shai_item:first-child {
                    margin-left: 5px;
                }
            }
            .search{
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 15px;
                width: 60px;
                height: 30px;
                font-size: 12px;
                color: #9094a6;
                cursor: pointer;
                box-sizing: border-box;
                border: 1px solid #232b3d;
                border-radius: 4px;
                display: flex;
                // align-items: center;
                justify-content: center;
                line-height: 30px;
                .search_close_box{
                    width: 90px;
                    height: 90%;
                    // background: #000;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 2px;
                }
                .search_close{
                    width: 14px;
                    height: 14px;
                    // margin-top: 8px;
                }
                .el-icon-search{
                    margin-top: 9px;
                }
                span {
                    margin-left: 5px;
                }
                .search_detail {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 60px;
                    width: 0;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    font-size: 12px;
                    color: #9094a6;
                    cursor: pointer;
                    // padding: 0 10px;
                    box-sizing: border-box;
                    border: 1px solid #232b3d;
                    border-radius: 4px;
                    background: #32354e;
                    opacity: 0;
                    overflow: hidden;
                    pointer-events: none;
                    transition: width 0.3s ease, opacity 0.2s ease;
                    z-index: 2;

                    &.show {
                        width: 230px;
                        opacity: 1;
                        pointer-events: auto;
                    }
                    // input {
                    //     width: 80%;
                    //     height: 100%;
                    //     line-height: 30px;
                    //     // text-align: center;
                    //     font-size: 12px;
                    //     color: #9094a6;
                    //     cursor: pointer;
                    //     // padding: 0 10px;
                    //     box-sizing: border-box;
                    //     border: none;
                    //     background: transparent;
                    //     outline: none;
                    //     text-indent: 5px;
                    // }
                    el-input{
                        width: 100%;
                    }
                        .el-input__inner {
                            width: 100%;
                            height: 100%;
                            line-height: 30px;
                            // text-align: center;
                            font-size: 12px;
                            color: #9094a6;
                            cursor: pointer;
                            // padding: 0 10px;
                            box-sizing: border-box;
                            border: none;
                            background: transparent;
                            outline: none;
                            text-indent: 5px;
                            padding: 0;
                        }
                        .el-input__icon {
                            line-height: 30px;
                        }
                }
            }
        }

        .tool_list {
            max-height: calc(100vh - 220px);
            padding: 0 10px 10px;
            padding-right: 4px; // 给滚动条留出视觉空间,但不影响布局
            margin: 10px 0;
            overflow-y: auto;
            overflow-x: hidden;

            // 滚动条浮动在内容上方,不占据布局空间
            &::-webkit-scrollbar {
                width: 6px;
                position: absolute; // 浮动定位
            }

            &::-webkit-scrollbar-button {
                display: none; // 移除上下箭头
            }

            // 默认完全透明(隐藏)
            &::-webkit-scrollbar-thumb {
                background-color: transparent;
                border-radius: 3px;
                transition: background-color 0.3s ease;
            }

            &::-webkit-scrollbar-track {
                background-color: transparent;
            }

            // 鼠标移入显示滚动条
            &:hover::-webkit-scrollbar-thumb {
                background-color: rgba(255, 255, 255, 0.3);
            }

            &:hover::-webkit-scrollbar-track {
                background-color: rgba(0, 0, 0, 0.1);
            }

            // 火狐浏览器滚动条样式 - overlay模式
            scrollbar-width: thin;
            scrollbar-color: transparent transparent; // 默认透明
            scrollbar-gutter: stable; // 保持内容稳定,滚动条不影响布局

            &:hover {
                scrollbar-color: rgba(255, 255, 255, 0.3) rgba(0, 0, 0, 0.1);
            }
            .masonry {
                column-count: 2;
                column-gap: 10px;
            }

            .masonry-item {
                break-inside: avoid;
                margin-bottom: 10px;
                width: 100%;
                background: #1e1f22;
                border-radius: 6px;
                overflow: hidden;
                cursor: pointer;
                position: relative;
                // 当图片加载失败时会通过内联style设置固定高度
            }

            .masonry-item .cover_img {
                width: 100%;
                height: auto;
                display: block;
                object-fit: cover;
                z-index: 99;
                position: relative;
                // transform: scale(1.8);

            }
            .masonry-item:hover .cover_img {
                z-index: 1;
            }
            .masonry-item:hover .btn {
                display: block;
            }

            .masonry-item .btn {
                width: 66px;
                height: 21px;
                backdrop-filter: blur(10px) saturate(180%);
                -webkit-backdrop-filter: blur(10px) saturate(180%);
                background: hsla(0, 0%, 100%, .2);
                border: 1px solid hsla(0, 0%, 100%, .2);
                border-radius: 8px 8px 8px 8px;
                color: #fff;
                font-size: 12px;
                line-height: 21px;
                text-align: center;
                position: absolute;
                bottom: 10px;
                left: 50%;
                transform: translateX(-50%);
                display: none;
                z-index: 100;
            }

            .load-more-sentinel {
                width: 100%;
                height: 1px;
            }
        }
    }
}
</style>